import { TasksOverviewItem } from '@intelligent-play-v2/domain';
import { queryBuilder } from '~/api';

export const getTasksOverview = async (): Promise<TasksOverviewItem[]> => {
  const { data } = await queryBuilder('GET', 'calendar/tasksOverview');
  return data;
};
